import React from 'react';
import { connect } from 'react-redux';
import arrayMove from 'array-move';
import { toDateFormat } from 'utils/helpers/timestampHelper';
import Loader from 'features/Loader/Loader';
import { updateClientWorkoutsOrder } from 'features/clientProfile/ducks/clientProfileActions';
import WorkoutLastLog from './WorkoutLastLog';
import WorkoutList from './WorkoutList';
import './WorkoutTab.scss';

class WorkoutTab extends React.Component {
  constructor(props){
    super(props);
    this.clientId = props.clientId;
    this.state = {
      workouts: props.workouts,
      order: props.order || {}
    };
  }

  sortingWorkouts = (workouts, order={}) => {
    return workouts.sort((workout1, workout2) => {
      let assigned_at2 = workout2.clients_data && workout2.clients_data[`${this.clientId}`] &&
        toDateFormat(workout2.clients_data[`${this.clientId}`].assigned_at);
      let assigned_at1 = workout1.clients_data && workout1.clients_data[`${this.clientId}`] &&
        toDateFormat(workout1.clients_data[`${this.clientId}`].assigned_at);
      return (
        (order[`${workout1.id}`] - order[`${workout2.id}`])
        || assigned_at2 - assigned_at1
      );
    });
  }

  componentWillReceiveProps({workouts, order}) {
    this.setState({
      workouts: this.sortingWorkouts(workouts, order),
      order: order
    })
  }

  componentDidMount() {
    let { workouts, order } = this.props;
    this.setState({
      workouts: this.sortingWorkouts(workouts, order),
      order: order
    })
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    let newWorkouts = arrayMove(this.state.workouts, oldIndex, newIndex);
    let newOrder = {};
    newWorkouts.forEach((workout, index) => {
      newOrder[`${workout.id}`] = index + 1;
    })
    this.setState({
      workouts: newWorkouts,
      order: newOrder
    });
    this.props.updateClientWorkoutsOrder(this.clientId, newOrder);
  };

  render() {
    let { workouts } = this.state;
    let { clientWorkoutLastLogged, loading, loadingLastLogedWorkout } = this.props;
    if(loading || loadingLastLogedWorkout){
      return(<Loader />);
    }
    return (
      <div className="workout-tab">
        {
          !!Object.keys(clientWorkoutLastLogged).length &&
            <WorkoutLastLog clientId={this.clientId} workoutLog={clientWorkoutLastLogged}/>
        }
        {
          workouts &&
            <WorkoutList
              workouts={workouts}
              clientId={this.clientId}
              onSortEnd={this.onSortEnd}
              useDragHandle
            />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.workoutReducer.loading,
    loadingLastLogedWorkout: state.clientProfileWorkoutReducer.loadingLastLogedWorkout
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateClientWorkoutsOrder: (clientId, order) =>
      dispatch(updateClientWorkoutsOrder(clientId, order))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkoutTab);
